$(document).ready(function () {
    initRequestCreate();
});

function initRequestCreate() {
    let block = $('.request-create-form');
    if (block.length === 0) {
        return;
    }

    initSelect2();

    block
        .on('change', '#id_region', function () {
            $('#id_address').val('');
            $('#id_device').val('');
            request_update_selects('regions');
        })
        .on('change', '#id_address', function () {
            $('#id_device').val('');
            request_update_selects('addresses');
        })
        .on('change', '#id_device', function () {
            request_update_selects('devices');
        })
        .on('change', '#id_type', function () {
            request_update_problem();
        })
    ;
}

function request_update_selects(type) {
    let data = {
        action: 'selects',
        region: $('#id_region').val(),
        address: $('#id_address').val(),
        device_uid: $('#id_device').val()
    };
    let url = '/requests/create/ajax/';
    sendPost(url, data, function (response) {
        request_update_select('regions', response.data, type);
        request_update_select('addresses', response.data, type);
        request_update_select('devices', response.data, type);
    });
}

function request_update_problem() {
    let data = {
        action: 'selects_problem',
        request_type: $('#id_type').val(),
    };
    let url = '/requests/create/ajax/';
    sendPost(url, data, function (response) {
        change_problem(response.data);
    });
}

function change_problem(data) {
    let block;
    block = $('#id_problem');
    let values = data['problem_choices'];
    let current_value = block.val();
    block.empty();
    values.forEach(function (value) {
        block.append($('<option/>').attr('value', value[0]).text(value[1]));
    });
    if (values.length === 1) {
        block.val(values[0][0]);
    }
}

function request_update_select(type, data, update_type) {
    let block;
    let values = data[type];

    if (type === 'regions') {
        block = $('#id_region');
    } else if (type === 'addresses') {
        block = $('#id_address');
    } else if (type === 'devices') {
        block = $('#id_device');
    }

    if (block.length === 0) {
        return;
    }

    let current_value = block.val();
    let last_value = null;
    block.empty();

    values.forEach(function (value) {
        last_value = value[0];
        block.append($('<option/>').attr('value', value[0]).text(value[1]));
    });

    let set_value = false;
    if (values.length === 2 && last_value.length > 0 && type !== update_type) {
        set_value = true;
    } else if (current_value && current_value.length !== 0 && type === update_type) {
        set_value = true;
    }

    if (set_value) {
        block.val(last_value);
    }
}